// extracted by mini-css-extract-plugin
module.exports = {"trading":"index_trading__teqUK","tradingcontent":"index_tradingcontent__l_N_U","learns":"index_learns__obxbh"};